//get all employees

import { IEmployee } from './employee';
import { apiClient } from './axios';

export interface CustomerFormData {
  sellerId?: number;
  fullName: string;
  phoneNumber: string;
  email?: string | null;
  dateOfBirth?: string;
  gender?: string;
  address?: string | null;
  workAddress?: string | null;
  hobbies?: string | null;
  style?: string | null;
  favoriteColor?: string | null;
  notes?: string | null;
  maritalStatus?: string | null;
  spouseName?: string | null;
  spouseBirthday?: string | null;
  specialNotes?: string | null;
  phoneFamily?: string | null;
}

export interface ICustomer {
  id: string;
  seller: IEmployee;
  fullName: string;
  phoneNumber: string;
  email: string;
  dateOfBirth: string;
  gender: string;
  address: string;
  hobbies: string;
  style: string;
  favoriteColor: string;
  notes: string;
  maritalStatus: string;
  spouseName: string;
  spouseBirthday: string;
  specialNotes: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: string;
  createdBy: IEmployee;
  phoneFamily: string;
  workAddress: string;
  orderCount: number;
  giftRequestCount: number;
}

export interface CustomerResponse {
  items: ICustomer[];
  totalItems: number;
  currentPage: number;
  totalPages: number;
  hasNextPage: boolean;
}

export interface HistorySellerResponse {
  id: string;
  customer: ICustomer;
  oldSeller: IEmployee;
  newSeller: IEmployee;
  changedBy: IEmployee;
  changedAt: string;
}

export const getCustomers = async (
  page: number,
  limit: number,
  search: string,
  sellerId: string | null
): Promise<CustomerResponse> => {
  const response = await apiClient.get<CustomerResponse>('customers', {
    params: {
      page,
      limit,
      orderBy: 'createdAt:DESC',
      search,
      sellerId,
    },
  });
  if (!response.success) {
    throw new Error(response.message);
  }
  return response.data;
};

export const getAllCustomers = async (): Promise<ICustomer[]> => {
  const response = await apiClient.get<ICustomer[]>('customers/all');
  return response.data;
};

export const createCustomer = async (data: CustomerFormData) => {
  const response = await apiClient.post('customers', data);
  if (!response.success) {
    throw new Error(response.message);
  }
  return response.data;
};

export const updateCustomer = async (id: string, data: CustomerFormData) => {
  const response = await apiClient.patch(`customers/${id}`, data);
  if (!response.success) {
    throw new Error(response.message);
  }
  return response.data;
};

//delete customer
export const deleteCustomer = async (id: string) => {
  const response = await apiClient.delete(`customers/${id}`);
  if (!response.success && response?.error) {
    throw new Error(response.message);
  }
  return response.data;
};

export const getHistorySeller = async (
  id: string | null
): Promise<HistorySellerResponse[]> => {
  const response = await apiClient.get<HistorySellerResponse[]>(
    `customers/${id}/seller-history`
  );
  return response.data;
};
